import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function normalizeNumberInput(value, fallback = 0) {
  if (value === "" || value === null || value === undefined) return fallback;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function sanitizeLeadingZeroInput(value) {
  if (value === "" || value === null || value === undefined) return "";
  const text = String(value);
  if (/^0\d+$/.test(text)) return text.replace(/^0+/, "") || "0";
  if (/^-0\d+$/.test(text)) return `-${text.replace(/^-0+/, "") || "0"}`;
  return text;
}
